import { render, staticRenderFns } from "./contact.vue?vue&type=template&id=7900f2e8&"
import script from "./contact.vue?vue&type=script&lang=js&"
export * from "./contact.vue?vue&type=script&lang=js&"
import style0 from "./contact.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/php7/nickyeconomou.com/public/site/nickyeconomou/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7900f2e8')) {
      api.createRecord('7900f2e8', component.options)
    } else {
      api.reload('7900f2e8', component.options)
    }
    module.hot.accept("./contact.vue?vue&type=template&id=7900f2e8&", function () {
      api.rerender('7900f2e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/pages/contact.vue"
export default component.exports